// SearchComponent.jsx
import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Box,
  Paper,
  Skeleton,
  useMediaQuery,
  useTheme,
  Container,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  //useTheme,
  Chip,
  IconButton,
} from "@mui/material";
import FactCheckDisplay from '../FactCheckDisplay';
import './animation.css'; // Ensure .search-container styles are removed/commented out
import './scrollbar.css';
import { useAppContext } from '../AppProvider';
import { v4 as uuidv4 } from 'uuid';
import SearchBar from './searchBar';
import ErrorComponent from './ErrorComponent';
import VideoParagraphComponent from '../videoExpand';
import { useAuth0 } from '@auth0/auth0-react';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from "axios";
import HeadlineDisplay from './HeadlineDisplay';

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExampleCards from "./Examples";

import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

import { Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { Link } from 'react-router-dom';


import { Image as ImageIcon, Description as FileTextIcon, YouTube as YoutubeIcon, TextFields as TextIcon, UnfoldLess as UnfoldLessIcon, UnfoldMore as UnfoldMoreIcon } from "@mui/icons-material";

const SearchComponent = ({ isSearchMoved, setIsSearchMoved, isMdUp, initialUrlParam }) => {
  //const [searchQuery, setSearchQuery] = useState("");
  const [isProMode, setIsProMode] = useState(false);
  const { user, getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [searchVersion, setSearchVersion] = useState("basic"); // Default to 'basic'
  const [resultVersion, setResultVersion] = useState("basic"); // Default to 'basic'
  const [userVersion, setUserVersion] = useState("basic")
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [manualRefresh, setManualRefresh] = useState(false) // I am adding this for state update trigger
  const [searchCount, setSearchCount] = useState(0);
  const [isProDialogOpen, setProDialogOpen] = useState(false);
  const [showExamples, setShowExamples] = useState(true);


  useEffect(() => {
    // Check the screen height when the component mounts
    if (window.innerHeight <= 400) {
      setShowExamples(false); // Set showExamples to false for small screen heights
    }
  }, []); // Empty dependency array to run once on mount

  const navigate = useNavigate(); // React Router's navigation hook
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    version,
    setVersion,
    currentConversation,
    setConversations,
    setCurrentConversation,
    queries,
    setQueries,
    email,
    ids,
    workspaceLoading,
    mode,
    link,
    setLink,
    setIdHistory,
    setMode,
    errorDisplay,
    setErrorDisplay,
    setNewSearch,
    setOverlayLogin,
    hideSearchBar,
    setHideSearchBar,
    skipDisambiguation,
    isProUser,
    backendUrl,
    headlines,
    sourceFindMode,
    userCredits,
    creditsLoading,
    searchQuery, setSearchQuery,
    setRun, setForceRun
  } = useAppContext();
  
  //const theme = useTheme();
  // const isSmUp = useMediaQuery(theme.breakpoints.up('sm')); // >=600px
  // const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // >=900px
  const scrollableDivRef = useRef(null);
  const bottomRef = useRef(null); // **New Ref for Sentinel Element**

  const [text, setText] = useState("");
  const fullText = "Let's get fact-checking!"; // The full text to type out
  const typingSpeed = 50; // Typing speed in milliseconds
  const indexRef = useRef(0); // To keep track of the current index
  const timeoutRef = useRef(null); // To store the timeout ID

  const [internalTrigger, setInternalTrigger] = useState(true)
  const [externalTrigger, setExternalTrigger] = useState(true)
  const [conversationIdMatch, setConversationIdMatch] = useState(true)

  useEffect(() => {
    const checkUserConvoMapping = async () => {
      if (!currentConversation || !user?.email) return;
      
      try {
        const response = await fetch(backendUrl+`/check-convo-user-mapping`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // 'X-API-KEY': frontend_key,
          },
          body: JSON.stringify({
            userEmail: user.email,
            convoId: currentConversation,
          }),
        });
  
        console.log("user convo mapping response");
        console.log(response);
  
        if (!response.ok) {
          throw new Error('Failed to match convo id and user');
        }
  
        const data = await response.json();
        const convoMatch = data.id_match;
        console.log({convoMatch})
        if (convoMatch === false) {
          setConversationIdMatch(false);
        }
  
      } catch (error) {
        console.error('Error checking convo-user mapping:', error);
      }
    };
  
    checkUserConvoMapping();
  }, [currentConversation]);


  useEffect(() => {
    const typeWriter = () => {
      // Ensure that fullText is defined and index is within bounds
      if (indexRef.current < fullText.length) {
        const currentChar = fullText[indexRef.current];
        
        // Prevent appending undefined or null characters
        if (currentChar !== undefined && currentChar !== null) {
          setText((prev) => prev + currentChar);
          indexRef.current += 1;
          timeoutRef.current = setTimeout(typeWriter, typingSpeed);
        } else {
          // If currentChar is undefined or null, stop the typing
          clearTimeout(timeoutRef.current);
        }
      }
    };

    typeWriter();

    // Cleanup function to clear the timeout when the component unmounts
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setText(''); // Optional: Reset text when unmounting
      indexRef.current = 0; // Reset index
    };
  }, [fullText, typingSpeed]);


  const iconMap = {
    text: <TextIcon sx={{ color: "#757575", fontSize: { xs: 18, sm: 20, md: 24 } }} />,
    image: <ImageIcon sx={{ color: "#757575", fontSize: { xs: 18, sm: 20, md: 24 } }} />,
    video: <YoutubeIcon sx={{ color: "#757575", fontSize: { xs: 18, sm: 20, md: 24 } }} />,
    document: <FileTextIcon sx={{ color: "#757575", fontSize: { xs: 18, sm: 20, md: 24 } }} />,
  };
  
  

  const handleToggle = (event) => {
    setIsProMode(event.target.checked);
    setVersion(event.target.checked ? "pro" : "basic");
  };

  useEffect(() => {
    setIsProMode(version === "pro");
  }, [version]);

  useEffect(() => {
    setManualRefresh(!manualRefresh)
  }, [userCredits])

  const sendCurrentConversation = async (email, currentConversation, query) => {
    try {
      await fetch(backendUrl+'/update_ids', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email, // user email
          id: {
            id: currentConversation, // current conversation ID
            query: query // conversation query
          }
        })
      });
    } catch (error) {
      console.error("Error sending current conversation:", error);
    }
  };

  const isUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  const checkCreditBalance = async (queryType) => {
    var message = ""
    if(queryType == 'short'){
          message = 'You have exhausted your daily fact-checking credits. Kindly upgrade your subscription or wait until tomorrow for the credits to refresh or refer a friend to get more credits.'
    }
    else{
        message = "You've exhausted your daily fact-checking credits. We will still extract claims, but full fact-checks are paused. Kindly upgrade or refer a friend to get more credits "
    }
    const creditValue = userCredits
    console.log(creditValue)
    if(creditValue == 0 && !creditsLoading){
      setToastMessage(message)
      setToastOpen(true)
    }
  }

  const handleSearchClick = async () => {
    console.log("in handlesearch")
    await checkCreditBalance()

    
    setErrorDisplay("");
    // Clear the search input and move the search UI if needed
    setSearchQuery("");
    setIsSearchMoved(true);
    const trimmedQuery = searchQuery.trim();

    if (!trimmedQuery) return;

    // console.log("searchCount is: ", searchCount)
    // console.log("isURL: ", isUrl(trimmedQuery))
    if(!isAuthenticated && searchCount >=1 || !isAuthenticated && isUrl(trimmedQuery) || !isAuthenticated && trimmedQuery.length>250){
      // alert('Please login to continue searching');
      setOverlayLogin(true)
      return;
    }



    let newMode = mode;
    let newQueries = [...queries];
    // console.log({ newQueries });
    let newLink = null;

    let newSearchState = false;
    // Determine if a new conversation should be started
    const shouldStartNewConversation =
      queries.length === 0 || isUrl(trimmedQuery) || mode === 'extractFacts' || conversationIdMatch === false;

    if (sourceFindMode===false){
      if (isUrl(trimmedQuery)) {
        await checkCreditBalance('long')
        newLink = trimmedQuery;
        newQueries = [trimmedQuery];
        newMode = 'extractFacts';
        setNewSearch(true);
      } else if (trimmedQuery.length > 250){
        await checkCreditBalance('long')
        newLink = trimmedQuery;
        newQueries = [trimmedQuery];
        newMode = 'extractFacts';
        setNewSearch(true);
      } else if (mode === 'extractFacts') {
        await checkCreditBalance('short')
        newMode = 'verify';
        newQueries = [trimmedQuery];
        setNewSearch(true);
        setManualRefresh(!manualRefresh)
      } else {
        await checkCreditBalance('short')
        if (!conversationIdMatch){
          newMode = 'verify';
          newQueries = [trimmedQuery];
          setNewSearch(true);
          setManualRefresh(!manualRefresh)
        }else{
          newMode = 'verify';
          newQueries.push(trimmedQuery);
          setManualRefresh(!manualRefresh)
        }

      }
    }else{
      await checkCreditBalance('short')
      setManualRefresh(!manualRefresh) 
      if (!conversationIdMatch){
        newMode = 'verify';
        newQueries = [trimmedQuery];
        setNewSearch(true)
      } else{
        newMode = 'verify';
        newQueries.push(trimmedQuery);
        setManualRefresh(!manualRefresh)
      }    
    }

    // Update states based on the above decisions
    if (newLink) setLink(newLink);
    setMode(newMode);
    setQueries(newQueries);
    // console.log({ trimmedQuery });

    if (shouldStartNewConversation) {
      setIdHistory({});
      let newConversationId = ""
      if (isAuthenticated){
        newConversationId = uuidv4();
      }else{
        newConversationId = "";

      }
      setCurrentConversation(newConversationId);

      setConversations((prevIds) => [
        ...prevIds,
        { query: trimmedQuery, id: newConversationId },
      ]);

      // Send conversation data and update URL without page navigation
      await sendCurrentConversation(email, newConversationId, trimmedQuery);
      window.history.replaceState(null, "", `/c/${newConversationId}`);
    }
    if(!isAuthenticated){
      setSearchCount(searchCount + 1)
    }
  };


  // useEffect(() => {
  //   console.log({ queries });
  // }, [queries]);

  // **Remove the previous useEffect for scrolling based on queries**

  // **Add a new useEffect to scroll to the sentinel element after each render**
  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [queries, workspaceLoading, mode, link]); // Add dependencies as needed

  // useEffect(() => {
  //   console.log("use effect check daily credits left")

  //   const checkCreditBalance = async () => {
  //     try {
      
  //     const response = await axios.post(`${backendUrl}/check_credits_util`, {
  //       userEmail: user.email,
  //     });
  //     if(response.data.success){
  //       const alertValue = false
  //       alertValue = response.data.userCredits == 0 ? true: false
  //       console.log(response.data.userCredits )
  //       setToastMessage("You have exhausted your daily fact-checking limits. Kindly upgrade your subscription or wait until tomorrow for the credits to refresh.")
  //       setToastOpen(true)
  //       setManualRefresh(!manualRefresh)
  //     }
  //     }
  //     catch{

  //     }
  //   }

  //   if(mode == 'verify')
  //     {
  //       checkCreditBalance();
  //     }
  // }, [manualRefresh])

  useEffect(() => {
    console.log("use effect checkPro running")
    const checkProSearches = async () => {
      try {
        if(isProUser == false){
          const response = await axios.post(`${backendUrl}/check_pro_searches`, {
            userEmail: user.email,
          });
          //truth table logic
          // if sys is pro, user search pro -> pro
          // if sys is basic, user search basic -> basic
          // if sys is pro, user basic -> basic => alert/toast
          // if sys is basic, user pro -> basic
          
          if(response.data.success)
          {
            const userSearch = response.data.hasProSearches? 'pro': 'basic'
            console.log("userSearch is: ", userSearch)

            if(version == 'pro' && userSearch == 'pro')
            {
              setSearchVersion("pro")
              setResultVersion("pro")
            }
            else if (version == 'basic' && userSearch == 'basic') {
            setSearchVersion("basic")
            setResultVersion("basic")
            }
            else if (version == 'pro' && userSearch == 'basic') // throw toastie
            {
                setToastMessage("You have exhausted your 'pro' searches for the day. Your searches will be processed using 'basic' mode.");
                setToastOpen(true);
                setProDialogOpen(true)
                setSearchVersion("basic")
                setResultVersion("basic")
                setVersion("basic")
              }
            else {
              setSearchVersion("basic")
              setResultVersion("basic")
            }      

          }
          else{
            setSearchVersion("basic")
            setResultVersion("basic")
          }       

        }
        else { //user has a pro subscription
          setSearchVersion("pro")
          setResultVersion(version)
        }
      } catch (error) {
        console.error("Error checking pro searches:", error);
        setSearchVersion("basic"); // Fallback to 'basic' on error
      }
    };
    if(mode == 'verify')
    {
      //checkProSearches();
    }
  }, [manualRefresh]); // Run on component mount

  const handleCloseToast = () => {
    setToastOpen(false);
  };

  const handleProDialogClose = () => {
    setProDialogOpen(false);
  };

  const sampleRecommendations = [
    {
      type: 'text',
      content: 'Mr Beast has sold his YouTube channel to Disney.',
      title: 'None',
    },
    {
      type: 'video',
      content: 'https://www.youtube.com/watch?v=HeG-laB_YL4',
      title: "Never Eat Broccoli with This🥦 Cause Cancer ..",
    },
    {
      type: 'text',
      content: 'Bananas are a type of berries',
      title: 'None',
    },
    {
      type: 'video',
      content: 'https://www.youtube.com/shorts/6hM6j4zyEjU',
      title: "Spicy food and stomach ulcers",
    }
  ];

  const handleCardClick = (query) => {
    setSearchQuery(query);
    setInternalTrigger((prevState) => !prevState);
  };
  
  // const handleCardClick = (sample) => {
  //   setSearchQuery(sample.content);
  //   setInternalTrigger((prevState) => !prevState);
  //   // We can set a short timeout to ensure the query updates
  //   // setTimeout(() => {
  //   //   initiateSearch();
  //   // }, 0);
  // };

  useEffect(() => {
    // Trigger an external toggle when `searchQuery` chnges
    setExternalTrigger((prevState) => !prevState); // Toggle the state
  }, [internalTrigger, setExternalTrigger]);

  useEffect(() => {
    if (initialUrlParam) {
      setSearchQuery(initialUrlParam);
      // Delay handleCardClick by 2 seconds
      setTimeout(() => {
        handleCardClick(initialUrlParam);
        // Then wait 100ms before handleSearchClick
        setTimeout(() => {
          handleSearchClick();
        }, 100);
      }, 2000);
    }
  }, [initialUrlParam]);
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%', // Changed from '100vh' 
        
        width: '100%',
        position: 'relative',
        backgroundColor: 'transparent',
        overflow: 'hidden', // Prevent overflow
        // border: '2px solid red', // **Border Added for Debugging**
        boxSizing: 'border-box', // Ensures padding and border are included in the element's total width and height
      }}
    >
      {/* **Text Element Snapped to the Top** */}


      {/* {!queries.length && !errorDisplay && !workspaceLoading && (
        <Box
          // sx={{
          //   width: '100%',
          //   padding: '16px 0', // Add vertical padding
          //   textAlign: 'center',
          //   backgroundColor: 'transparent', // Adjust if needed
          //   zIndex: 1, // Ensure it's above other elements if overlapping
          //   marginTop: isMdUp?'20vh':'15vh'
          // }}
          sx={{

            position: 'fixed',
            left: '50%',
            bottom: isSearchMoved ? '45px' : '55%', // 35px (SearchBar bottom) + 10px or centered adjustment
            transform: isSearchMoved
              ? 'translateX(-50%)'
              : 'translate(-50%, -50%)',
            zIndex: 1001, // Higher than SearchBar to ensure visibility
            pointerEvents: 'none', // Allow clicks to pass through
            textAlign: 'center',
            zIndex: -3000,
            width: '100%'
          }}
        >
          <Typography
            variant= {isMdUp?"h4":"h5"}
            color="#0066FF"
            sx={{
              boxSizing: 'border-box',
            }}
          >
            {text}
          </Typography>
        </Box>
      )} */}

      {/* Fixed Container for Search Bar */}
<Box
  sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: isSearchMoved ? 'flex-end' : 'center',
    //alignItems: 'flex-end',
    position: 'fixed', // Changed from 'absolute' to 'fixed'
    top: isSearchMoved ? 'auto' : '50%',
    bottom: isSearchMoved ? '35px' : 'auto',
    //top: 'auto',
    //bottom: '35px',
    left: '50%',
    transform: isSearchMoved
      ? 'translateX(-50%)'
      : 'translate(-50%, -45%)',

    //transform: 'translateX(-50%)',
    transition: 'all 0.3s ease',
    width: {
      xs: '95%', // Mobile
      sm: '70%', // Small screens
      md: '50%', // Medium and up
    },
    maxWidth: '900px',
    zIndex: 1000, // Higher z-index to sit on top
    pointerEvents: 'none', // Allow clicks to pass through non-interactive areas
    flexDirection: 'column', // Stack vertically for both search bar and button
    gap: '16px', // Add spacing between SearchBar and button
    boxSizing: 'border-box',
    marginTop: {xs: '20px', sm: '20px'}

  }}
>
  <Box
    sx={{
      pointerEvents: 'auto', // Enable interactions within the SearchBar
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      flexDirection: 'column'
    }}
  >
{!isSearchMoved && (
  <>
    <Typography
    className = 'facti-tut-step-1'
      variant={isMdUp ? "h5" : "h6"}
      color="#0066FF"
      sx={{
        boxSizing: 'border-box',
      }}
    >
      {text}
    </Typography>

  </>
)}

    {/* <br></br> */}
    {/* <SearchBar
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleSearchClick={handleSearchClick}
      isProMode={isProMode}
      handleToggle={handleToggle}
      isSearchMoved={isSearchMoved}
      externalTrigger = {externalTrigger}
      sx={{
        padding: { xs: '12px 12px', sm: '12px 16px' },
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '800px',
        //margin: {xs: '12px', sm: '12px'}
      }}
    /> */}
 <>
    {!isSearchMoved && !hideSearchBar && (
      <div 
  style={{
    marginBottom: '10px',
    maxHeight: '70vh',
    overflow: 'hidden',
  }} 
  onMouseEnter={(e) => e.currentTarget.style.overflow = 'auto'}
  onMouseLeave={(e) => e.currentTarget.style.overflow = 'hidden'}
>         {/* Navigation Chips */}
<Box
  sx={{
    width: "100%",
    mt: 2,
    mb: "5px",
    px: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 1,
  }}
>
  {/* First row: three chips in a row even on mobile */}
  <Box
    sx={{
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 1,
      width: "100%",
    }}
  >
    <Chip
      label="Writer"
      clickable
      component="a"
      href="/writer"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.5,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
    <Chip
      label="API"
      clickable
      component="a"
      href="/api"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.25,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
    {/* Discover badge */}
    <Chip
      label="Discover"
      clickable
      component="a"
      href="/discover/feed"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.5,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
    <Chip
      label="Tutorial"
      clickable
      onClick={() => {
        setForceRun(true);
        setRun(true);
      }}
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.5,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
  </Box>

  {/* Second row: tutorial chip (stays below on all screens) */}
  <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
  <Chip
      label="Subscribe 7 days free!"
      clickable
      component="a"
      href="/subscription"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.5,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
    <Chip
      label="Chrome Extension"
      clickable
      component="a"
      href="https://chromewebstore.google.com/detail/facticity-ai-fact-checker/mlackneplpmmomaobipjjpebhgcgmocp"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.25,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
  </Box>
  <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
  <Chip
      label="Refer your friends to earn free credits"
      clickable
      component="a"
      href="/rewards"
      sx={{
        bgcolor: "#0066FF",
        color: "white",
        fontSize: "12px",
        px: 1,
        py: 0.25,
        "&:hover": { bgcolor: "#004FCC" },
      }}
    />
      
  </Box>
</Box>

    <Chip
  label="Features & Examples"
  clickable
  onClick={() => setShowExamples(!showExamples)}
  variant="outlined"
  sx={{
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center", // This ensures the chip is centered in the flex container
    width: "300px", // Adjust width as needed
    marginTop: '10px',
    marginLeft: 'auto',  // Optional: To handle the alignment if the parent container has specific constraints
    marginRight: 'auto'  // Optional: This will center the Chip
  }}
  //icon={showExamples ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  icon={showExamples ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
  //className='facti-tut-step-1'

/>

        <Collapse in={showExamples}>
          <br />
          
          <Typography
  variant="body1" // Keeping it consistent for body text
  color="text.primary"
  sx={{
    mt: 1, // Adds some space between the texts
    boxSizing: 'border-box',
    fontWeight: 400, // Regular font weight for clarity
    letterSpacing: "0.2px", // Slight letter spacing for elegance
    fontSize: { xs: '0.700rem', sm: '0.750rem', md: '0.850rem' }, // Adjust font size for small screens
    color: '#121212', // Even darker gray color
    display: { xs: 'none', sm: 'none', md: 'block' }, // Hide on mobile and small screens, show on medium and larger screens
  }}
>
  {`Our multi-modal and multi-lingual fact-checker can fact-check text claims, video URLs from social media platforms - try it out using the search bar below!`}
  {`Plus, meet the `}  
  <Link
    to="/writer"
    style={{
      color: "#0066FF", // Keeping the link color consistent with the theme
      textDecoration: "underline",
      fontWeight: 500, // Slightly bold to differentiate it
    }}
  >
    Facticity.AI "Writer"
  </Link>
  {` to assist you in essays, assignments, and research.`}
</Typography>

          <div className = 'facti-tut-step-2'>
          <ExampleCards  setSearchQuery={setSearchQuery} setInternalTrigger={setInternalTrigger} />
          </div>

          {!isSearchMoved && !hideSearchBar && headlines.length > 0 ? (
              <div className = 'facti-tut-step-3'>
                <HeadlineDisplay headlines={headlines?.slice(0, 10) || []} setSearchQuery={setSearchQuery} />
                </div>

                ) : (
                  <p></p>
            )}

        </Collapse>

        
      </div>
    )}
  </>
    
  {/* {!isSearchMoved && !hideSearchBar && headlines.length > 0 ? (
  <div>
      <HeadlineDisplay headlines={headlines?.slice(0, 10) || []} setSearchQuery={setSearchQuery} />
  </div>

) : (
  <p></p>
)} */}

    <Box>
    <div>


</div>




    </Box>
          <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' }, 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          width: '100%' 
        }}
      >
        

        {/* Search Bar */}
       
        <SearchBar
        
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleSearchClick={handleSearchClick}
          isProMode={isProMode}
          handleToggle={handleToggle}
          isSearchMoved={isSearchMoved}
          externalTrigger={externalTrigger}
          sx={{
            padding: { xs: '12px', sm: '12px 16px' },
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
            boxSizing: 'border-box',
            width: '100%',
            maxWidth: '800px'
          }}
        />

        {/* Credits Display */}
        {/* <Box sx={{ display: 'flex', alignItems: 'center', mt: { xs: 1, sm: 0 }, ml: '5px', background: 'white' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              Credits:
            </Typography>
            {creditsLoading ? (
              <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                Loading...
              </Typography>
            ) : (
              <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {userCredits}
              </Typography>
            )}

          </Box> */}
      </Box>




  </Box>

  {!isSearchMoved && (
  <Box
    sx={{
      pointerEvents: 'auto', // Enable interactions within the button
      width: '100%', // Ensure the button takes the same width as the SearchBar
      display: 'flex',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    {/* <a
      href="https://tally.so/r/mV1V0v"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: 'none',
      }}
    >
      <button
        style={{
          padding: '12px 24px',
          fontSize: '15px',
          borderRadius: '4px',
          backgroundColor: '#0066FF', // Blue background
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'center', // Center-align text within the button
        }}
      >
        Click here to join the waitlist of Facticity.AI's MS Word Add-in
        <br />
        and enjoy a one-month free trial!
      </button>
    </a> */}
  </Box>
)}
</Box>


      {/* Content Area */}
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1, // Allow the Container to grow and fill available space
          height: isSearchMoved ? 'calc(100% - 80px)' : '100%', // Conditional height
          transition: 'all 0.3s ease',
          position: 'relative',
          zIndex: 0, // Base layer
          mt: isSearchMoved ? 0 : 0, // Adjust top margin when search is moved
          overflow: 'hidden', // Prevent overflow
          // border: '2px solid blue', // **Border Added for Debugging**
          boxSizing: 'border-box',
        }}
      >
        {/* Loading State */}
        {workspaceLoading ? (
          <Box sx={{ width: '100%', mt: 4, boxSizing: 'border-box' }}> {/* **Border Added for Debugging** */}
            <Skeleton
              variant="text"
              sx={{ width: '100%', maxWidth: 800, mx: 'auto' }}
              height={60}
            />
            <Skeleton
              variant="rectangular"
              sx={{ width: '100%', maxWidth: 800, mx: 'auto' }}
              height={400}
            />
            <Skeleton
              variant="text"
              sx={{ width: '100%', maxWidth: 800, mx: 'auto' }}
              height={40}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              alignItems: 'center',
              justifyContent: queries.length ? 'flex-start' : 'center',
              overflow: 'hidden', // Prevent overflow
              // border: '2px solid brown', // **Border Added for Debugging**
              boxSizing: 'border-box',
            }}
          >
            {/* Initial State */}
            {!queries.length && (
              <Box
                sx={{
                  textAlign: 'center',
                  mb: 4,
                  // border: '2px solid teal', // **Border Added for Debugging**
                  boxSizing: 'border-box',
                }}
              >
                {errorDisplay ? (
                  <ErrorComponent errorDisplay={errorDisplay} />
                ) : (
                  <Box
                    sx={{
                      // Removed transform to prevent overlapping with fixed {text}
                      boxSizing: 'border-box',
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'nowrap', // Prevent wrapping
                      padding: '16px', // Optional: Add some padding
                      // Optional: Handle overflow if necessary
                      // overflow: 'hidden',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        // border: '2px solid lime', // **Border Added for Debugging**
                        boxSizing: 'border-box',
                        flexShrink: 0, // Prevent the image box from shrinking
                        marginRight: '16px', // Space between image and text
                      }}
                    >
                      {/* You can add an image or icon here if needed */}
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* Results Area */}
            {queries.length > 0 && (
              <Box
                ref={scrollableDivRef}
                className="scrollable-container"
                sx={{
                  width: '100%',
                  flexGrow: 1,
                  overflowY: 'auto', // Enable vertical scrolling
                  scrollBehavior: 'smooth',
                  // Removed mt: 2 and pb: 4 to reduce extra space
                  maxHeight: '80vh', // Set your desired max height
                  // border: '2px solid gray', // **Border Added for Debugging**
                  boxSizing: 'border-box',
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    width: '100%',
                    maxWidth: mode === 'verify' ? '1100px' : '2200px',
                    backgroundColor: 'transparent',
                    // border: '2px solid purple', // **Border Added for Debugging**
                    boxShadow: 'none',
                    borderRadius: '10px',
                    margin: 'auto',
                    // padding: { xs: 1, sm: 2 },
                    boxSizing: 'border-box',
                  }}
                >
                  {mode === 'verify' ? (
                    <>
                      {queries.map((query, index) => (
                        <FactCheckDisplay
                          key={index}
                          query={query}
                          id={ids[index] || null}
                          setDone={() => {}}
                          process
                          maxWidth="100%"
                          skipDisambiguation={skipDisambiguation}
                          sx={{
                            // border: "2px solid pink", // **Border Added for Debugging** (if FactCheckDisplay accepts sx prop)
                            boxSizing: "border-box",
                          
                          }}
                          version = {resultVersion}
                          isVideo = {false}
                          source_find_mode={sourceFindMode}
                          //isProUser = {isProUser}
                          
                        />
                      ))}
                      {/* Add line breaks here */}
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                    </>
                  ) : (
                    <VideoParagraphComponent
                      key={0}
                      id={0}
                      claim={link}
                      email={email}
                      readyin={false}
                      // sx={{
                      //   // border: '2px solid cyan', // **Border Added for Debugging** (if VideoParagraphComponent accepts sx prop)
                      //   boxSizing: 'border-box',
                      // }}
                      version = {searchVersion}
                    />
                  )}
                  {/* **Sentinel Element for Scrolling** */}
                  <div ref={bottomRef} 
                    style={{ height: 0, 
                      // border: '2px dotted black' 
                      }} /> {/* **Border Added for Debugging** */}
                </Paper>
              </Box>
            )}
          </Box>
        )}
      </Container>

      {/* Snackbar for toast */}
      <Snackbar
        open={toastOpen}
        //autoHideDuration={8000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseToast} severity="warning" sx={{ width: '100%' }}>
          {toastMessage}
        </Alert>
      </Snackbar>
      {/* Dialog Box to prompt pro subscription purchase */}

      <Dialog
      open={isProDialogOpen}
      onClose={handleProDialogClose}
      aria-labelledby="pro-signup-dialog-title"
      aria-describedby="pro-signup-dialog-description"
    >
      <DialogTitle id="pro-signup-dialog-title">Upgrade to Pro</DialogTitle>
      <DialogContent>
        <Typography id="pro-signup-dialog-description" sx={{ mt: 1 }}>
          You've reached the limit for 'pro' searches for the day. Upgrade to Pro to enjoy unlimited access to premium features, including advanced fact-checking and better results.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleProDialogClose} color="secondary">
          Not Now, Continue With Free
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleProDialogClose();
            //window.location.href = "/pricing"; // Navigate to pricing page
            navigate("/subscription")
          }}
        >
          Go Pro
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
  );
};

export default SearchComponent;
